document.addEventListener('DOMContentLoaded', () => {
	const brandsForm = document.querySelector('.productsBrands');

	if (brandsForm != null) {
		const showFilter = document.querySelector('.showFilter');
		const hideFilter = document.querySelector('.hideFilter');
		const filter = document.querySelector('.productsBrands');

		showFilter.addEventListener('click', () => {
			document.body.classList.add('lock');
			filter.classList.add('show');
		});

		hideFilter.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.remove('lock');
			filter.classList.remove('show');
		});
	}

	// single product tabs nav
	const tabnavs = document.querySelectorAll('.tabnav');
	const tabs = document.querySelectorAll('.tabs');

	function removeActive(items) {
		items.forEach((item) => {
			item.classList.remove('active');
		});
	}

	if (tabnavs.length) {
		tabnavs.forEach((item) => {
			item.addEventListener('click', () => {
				removeActive(tabnavs);
				removeActive(tabs);

				item.classList.add('active');
				document.querySelector(item.dataset.target).classList.add('active');
			});
		});
	}

	// single product: add to cart fixed
	const add2CartButtonHolder = document.querySelector('.cart-button-holder');
	const add2CartButton = document.querySelector('.cart-button-group');

	function fixedAdd2Cart() {
		if (window.innerWidth < 577 && document.querySelectorAll('.single-product').length) {
				const windowBottom = (window.scrollY + window.innerHeight) - add2CartButton.offsetHeight;

				windowBottom >= add2CartButtonHolder.offsetTop
					? add2CartButton.classList.add('fixed')
					: add2CartButton.classList.remove('fixed');
			}
	}

  	fixedAdd2Cart();

	document.addEventListener('scroll', fixedAdd2Cart);
});
